__turbopack_context__.v({
  "input__inlinebutton": "yEo3FW_input__inlinebutton",
  "newsletter": "yEo3FW_newsletter",
  "newsletter__input": "yEo3FW_newsletter__input",
  "newsletter_label": "yEo3FW_newsletter_label",
});
